import UpscTopicCardWhyInNews, {
  UpscTopicCardWhyInNewsVariant
} from './UpscTopicCardWhyInNews';
import UpscTopicCardKeyFacts from './UpscTopicCardKeyFacts';
import UpscTopicCardWayForward from './UpscTopicCardWayForward';
import UpscTopicCardMcqMains from './UpscTopicCardMcqMains';
import UpscTopicCardInstaLinks from './UpscTopicCardInstaLinks';
import { UpscTopicContentBlock } from './upscCurrentAffairsTopicTypes';

const UpscTopicContentBlockRenderer = ({
  block,
  whyInNewsVariant = 'detailed',
  detailPath
}: {
  block: UpscTopicContentBlock;
  whyInNewsVariant?: UpscTopicCardWhyInNewsVariant;
  detailPath?: string;
}) => {
  switch (block.component) {
    case 'text-block':
      return (
        <UpscTopicCardWhyInNews
          description={block.description}
          variant={whyInNewsVariant}
          detailPath={detailPath}
        />
      );
    case 'fact-session':
      return <UpscTopicCardKeyFacts keyFacts={block.keyFacts} />;
    case 'bullet-section':
      return <UpscTopicCardWayForward points={block.points} />;
    case 'mcq-section':
      return (
        <UpscTopicCardMcqMains
          mcq={block.mcq}
          mainsQuestion={block.mainsQuestion}
        />
      );
    case 'link-section':
      return <UpscTopicCardInstaLinks links={block.links} />;
    default:
      return null;
  }
};

export default UpscTopicContentBlockRenderer;
